import moment from "moment";
import { useEffect, useState } from "react";
import { GoSignOut } from "react-icons/go";
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import swal from "sweetalert";
import { requestAccountApi, requestApi } from "../../actions/api";
import { applyClassToCharacters, LoadingSpinner } from "../../constants/const";
import { encryptStorage } from "../../constants/EncryptStorage";
import { GetLanguageString } from "../helper/Components";
import Logout from "../logout/Logout";
import EventBarCodeAttendance from "./EventBarCodeAttendance";
import EventBarCodeAttendanceAhbab from "./EventBarCodeAttendanceAhbab";

import jwtDecode from "jwt-decode";
import "moment/locale/ur"; // make sure Urdu locale is loaded
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { encryptData } from "../../constants/EncryptData";
import { addMember } from "../member/ApiMember";
import { TbReportAnalytics } from "react-icons/tb";
import { RiArrowDropDownLine } from "react-icons/ri";

function getSafeDateFromClaim(claimKey) {
  const raw = encryptStorage.getItem(claimKey);

  if (!raw || raw === "0") return null;

  // Parse using Moment.js with strict 24-hour format
  const date = moment(raw.trim(), "DD/MM/YYYY HH:mm:ss", true).toDate();

  return isNaN(date.getTime()) ? null : date;
}

// Customize Urdu meridiem
moment.updateLocale("ur", {
  meridiem: function (hour, minute, isLower) {
    if (hour < 12) {
      return "صبح"; // morning
    } else if (hour < 16) {
      return "دوپہر"; // afternoon
    } else if (hour < 18) {
      return "شام"; // evening
    } else {
      return "رات"; // night
    }
  },
});

const EventSpecialAttendanceCase = ({
  history,
  setResponsibilityChangeLoading,
}) => {
  const eventId = encryptStorage.getItem("attendanceAccessEventId");
  const eventAttendanceAccessStartDate = getSafeDateFromClaim(
    "attendanceAccessEventStartDate"
  );
  const eventAttendanceAccessEndDate = getSafeDateFromClaim(
    "attendanceAccessEventEndDate"
  );
  const now = new Date();

  const memberId = parseInt(encryptStorage.getItem("memberId"));
  const userid = parseInt(encryptStorage.getItem("userId"));
  const responsibilityId = parseInt(encryptStorage.getItem("responsibilityId"));
  const responsibilityName = encryptStorage.getItem("responsibilityName");
  const [memberUnitDropDown, setMemberUnitDropDown] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("rufqa");
  const [returnLogout, setReturnLogout] = useState(false);
  const [loggedInResposibility, setLoggedInResposibility] = useState(null);
  const [memberResposibilityDropDown, setMemberResposibilityDropDown] =
    useState([]);
  const [loggedInDropDownOpen, setLoggedInDropDownOpen] = useState(false);
  const loggedInToggle = () =>
    setLoggedInDropDownOpen((prevState) => !prevState);
  const [eventValues, setEventValues] = useState({
    date: null,
    endDate: null,
    address: "",
    description: "",
    remarks: "",
    unit: {},
    eventType: {},
    canSubunitMarkAttendance: false,
    updateAllEvent: false,
  });
  const allowAttendance =
    new Date(eventAttendanceAccessStartDate) <= now &&
    now <= new Date(eventAttendanceAccessEndDate);
  if (responsibilityName !== "responsibility" && loggedInResposibility === null)
    setLoggedInResposibility(responsibilityName);

  useEffect(() => {
    if (
      memberResposibilityDropDown?.length === 0 &&
      memberUnitDropDown?.length === 0
    ) {
      addMember()
        .getDropDown(memberId)
        .then((res) => {
          setMemberResposibilityDropDown(res.data.responsibilities);
          setMemberUnitDropDown(res.data.units);
          // if (responsibilityName === "responsibility") {
          if (res.data.responsibilities !== null) {
            if (responsibilityId === res.data.responsibilities[0].value)
              setLoggedInResposibility(res.data.responsibilities[0].label);
            else {
              setLoggedInResposibility(
                res.data.responsibilities.find(
                  (e) => e.value === responsibilityId
                ).label
              );
            }
          } else if (res.data.units !== null) {
            setLoggedInResposibility(res.data.units[0].label);
          }
          // }
        })
        .catch((err) => console.log(err));
    }
  }, [
    memberId,
    memberResposibilityDropDown,
    memberUnitDropDown,
    responsibilityId,
  ]);

  const changeMemberResponsibilityOrUnit = (responsibilityId, unitId) => {
    setLoggedInResposibility(null);
    setResponsibilityChangeLoading(true);
    requestAccountApi()
      .changeResponsibility(responsibilityId, unitId, userid.toString())
      .then((res) => {
        encryptStorage.setItem("userClaims", res.data.userClaims);
        const getToken = res.data.token;
        var decodedToken = jwtDecode(getToken);
        if (decodedToken.role === "admin")
          encryptStorage.setItem("canManage", "true");
        else encryptStorage.setItem("canManage", decodedToken.CanManage);

        encryptStorage.setItem(
          "responsibilityName",
          decodedToken.ResponsibilityName
        );
        encryptStorage.setItem("memberId", decodedToken.MemberId);
        encryptStorage.setItem("userId", decodedToken.UserName);
        encryptStorage.setItem("loggedInUnitId", decodedToken.UnitId);
        encryptStorage.setItem("unitTypeName", decodedToken.UnitTypeName);
        encryptStorage.setItem("loggedInUnitName", decodedToken.UnitName);
        encryptStorage.setItem("memberRegNo", decodedToken.MemberRegNo);
        if (decodedToken?.AttendanceAccessEventId) {
          encryptStorage.setItem(
            "attendanceAccessEventId",
            decodedToken.AttendanceAccessEventId
          );
        } else {
          encryptStorage.removeItem("attendanceAccessEventId");
        }

        encryptStorage.setItem(
          "responsibilityId",
          decodedToken.ResponsibilityId
        );
        encryptStorage.setItem("token", JSON.stringify(getToken));
        encryptStorage.setItem(
          "refreshToken",
          JSON.stringify(res.data.refreshToken)
        );
        history.replace("/");

        window.onload = function () {
          // This function will be called once the page has finished reloading
          setResponsibilityChangeLoading(false);
        };
        // Reload the page
        window.location.reload();
      })
      .catch((err) => {
        setResponsibilityChangeLoading(false);
        swal({
          title: err,
          icon: "error",
          buttons: "OK",
        });
        console.log(err);
      });
  };

  useEffect(() => {
    setLoading(true);
    requestApi("event/")
      .fetchById(eventId)
      .then((res) => {
        setEventValues({
          ...res.data,
          date: res.data.date
            ? new Date(moment.utc(res.data.date).format("YYYY-MM-DD HH:mm:ss"))
            : null,
          endDate: res.data.endDate
            ? new Date(
                moment.utc(res.data.endDate).format("YYYY-MM-DD HH:mm:ss")
              )
            : null,
        });

        setLoading(false);
      })
      .catch((err) => {
        console.log("err", err);
        setLoading(false);
      });
  }, [eventId]);

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  if (returnLogout) return <Logout />;

  const message =
    now < eventAttendanceAccessStartDate
      ? "You cannot mark attendance yet, the event time has not started"
      : now > eventAttendanceAccessEndDate
      ? "You cannot mark attendance now, the event time has passed"
      : null; // null or empty if event is currently active

  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        background: "linear-gradient(135deg, #f8fafc, #e2e8f0)",
        overflow: "hidden",
        transition: "background 0.4s ease",
      }}
    >
      <>
        <header
          className="px-2 py-1 bg-white shadow-sm d-flex justify-content-between align-items-center"
          style={{
            borderBottom: "1px solid #e2e8f0",
            position: "sticky",
            top: 0,
            zIndex: 10,
            backdropFilter: "blur(10px)",
            WebkitBackdropFilter: "blur(10px)",
            boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
            animation: "fadeInDown 0.5s ease",
            transition: "all 0.3s ease",
          }}
        >
          {!loading ? (
            <>
              <div style={{ width: allowAttendance ? "22%" : "18%" }}></div>
              <div
                className="text-center flex-grow-1"
                style={{
                  color: "#0f172a",
                  fontSize: "1.8rem",
                  lineHeight: 2,
                  letterSpacing: "normal",
                  fontWeight: 600,
                  textRendering: "optimizeLegibility",
                  WebkitFontSmoothing: "antialiased",
                }}
              >
                <div className="ur">
                  {eventValues?.eventType?.label} ({eventValues?.description})
                </div>
                <div
                  className="ur"
                  style={{
                    fontWeight: 500,
                    color: "#334155",
                    fontSize: "1.4rem",
                    lineHeight: 1,
                    letterSpacing: "normal",
                    textRendering: "optimizeLegibility",
                    WebkitFontSmoothing: "antialiased",
                  }}
                >
                  {eventValues?.address}
                </div>
                <div
                  style={{
                    marginTop: 4,
                    fontSize: "1.2rem",
                    color: "#475569",
                    letterSpacing: "normal",
                    textRendering: "optimizeLegibility",
                    WebkitFontSmoothing: "antialiased",
                  }}
                >
                  <span>
                    {applyClassToCharacters(
                      moment(eventValues?.date).format("DD/MM/yyyy - hh:mm a"),
                      "ur"
                    )}{" "}
                    {" to "}
                    {applyClassToCharacters(
                      moment(eventValues?.endDate).format(
                        "DD/MM/yyyy - hh:mm a"
                      ),
                      "ur"
                    )}{" "}
                  </span>
                </div>
                <div
                  style={{
                    fontSize: "0.95rem",
                    color: "#475569",
                  }}
                >
                  <span style={{ fontWeight: "bold" }}></span>
                </div>
              </div>
              {allowAttendance ? (
                <a
                  href={`/eventReports/summaryReport?data=${encryptData({
                    eventId: eventId,
                    eventAddress: eventValues.address,
                    eventType: eventValues.eventType.label,
                    eventDate: eventValues.date,
                    eventUnitId: eventValues.unit.value,
                    eventUnitType: eventValues.unit.label1,
                    eventFilterExist: eventValues.filterExist,
                    showListTab: true,
                  })}`}
                  target="_blank" // open in new tab
                  rel="noopener noreferrer" // security best practice
                  style={{ color: "#1e293b", textDecoration: "none" }} // make text black and remove underline
                >
                  {" "}
                  <Button
                    className="d-flex align-items-center"
                    style={{
                      fontSize: "0.9rem",
                      cursor: "pointer",
                      color: "#ffffff",
                      background: "#4b7bacff",
                      border: "none",
                      borderRadius: "10px",
                      padding: "7px 16px",
                      fontWeight: 500,
                      boxShadow: "inset 0 0 5px rgba(0,0,0,0.05)",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = "#3c5e8aff";
                      e.currentTarget.style.transform = "translateY(-2px)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = "#4b7bacff";
                      e.currentTarget.style.transform = "translateY(0)";
                    }}
                  >
                    {" "}
                    <TbReportAnalytics
                      color="#ffffff"
                      size={18}
                      style={{ marginRight: 5, marginBottom: 1 }}
                    />
                    <GetLanguageString props="common_view_report" />
                  </Button>
                </a>
              ) : null}
              &nbsp;&nbsp;&nbsp;&nbsp;
              <Dropdown isOpen={loggedInDropDownOpen} toggle={loggedInToggle}>
                <DropdownToggle
                  className="ur"
                  style={{
                    color: "#ffffff",
                    background: "#4b7bacff",
                    border: "none",
                    borderRadius: "10px",
                    padding: "7px 16px",
                    fontWeight: 500,
                    fontSize: "0.9rem",
                    boxShadow: "inset 0 0 5px rgba(0,0,0,0.05)",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#3c5e8aff";
                    e.currentTarget.style.transform = "translateY(-2px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "#4b7bacff";
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                >
                  {" "}
                  <RiArrowDropDownLine
                    color="#ffffff"
                    size={22}
                    style={{ marginRight: 5, marginBottom: 1 }}
                  />
                  {loggedInResposibility}
                </DropdownToggle>

                <DropdownMenu>
                  {memberResposibilityDropDown?.map((record, index) => (
                    <DropdownItem
                      style={{
                        color: "#1e293b",
                      }}
                      className="ur"
                      key={index}
                      onClick={() => {
                        changeMemberResponsibilityOrUnit(
                          record.value,
                          0,
                          record.label
                        );
                      }}
                    >
                      {record.label}
                    </DropdownItem>
                  ))}

                  {memberUnitDropDown?.map((record, index) => (
                    <DropdownItem
                      style={{
                        color: "#1e293b",
                      }}
                      className="ur"
                      key={index}
                      onClick={() => {
                        changeMemberResponsibilityOrUnit(
                          0,
                          record.value,
                          record.label
                        );
                      }}
                    >
                      {record.label}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <Button
                onClick={() => setReturnLogout(true)}
                className="d-flex align-items-center"
                style={{
                  fontSize: "0.9rem",
                  cursor: "pointer",
                  color: "#ffffff",
                  background: "#4b7bacff",
                  border: "none",
                  borderRadius: "10px",
                  padding: "7px 16px",
                  fontWeight: 500,
                  boxShadow: "inset 0 0 5px rgba(0,0,0,0.05)",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "#3c5e8aff";
                  e.currentTarget.style.transform = "translateY(-2px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "#4b7bacff";
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                <GoSignOut
                  color="#ffffff"
                  size={18}
                  style={{ marginRight: 5, marginBottom: 1 }}
                />
                <span>{<GetLanguageString props="common_log_out" />}</span>
              </Button>
            </>
          ) : (
            <div className="text-center flex-grow-1">{LoadingSpinner()}</div>
          )}
        </header>
        {allowAttendance ? (
          <main
            className="flex-grow-1 p-1"
            style={{
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
              animation: "fadeInUp 0.5s ease",
            }}
          >
            <div
              className="flex-grow-1 rounded-4 border shadow-sm"
              style={{
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                background: "rgba(255,255,255,0.85)",
                backdropFilter: "blur(10px)",
                border: "1px solid #e5e7eb",
                boxShadow: "0 4px 20px rgba(0,0,0,0.04)",
                transition: "box-shadow 0.3s ease",
              }}
            >
              {/* Tabs Header */}
              <Nav
                tabs
                justified
                style={{
                  backgroundColor: "rgba(249,250,251,0.7)",
                  borderBottom: "1px solid #e5e7eb",
                  borderRadius: "16px 16px 0 0",
                  backdropFilter: "blur(6px)",
                  boxShadow: "inset 0 -1px 3px rgba(0,0,0,0.04)",
                }}
              >
                {[
                  { id: "rufqa", label: "unit_non_responsible_member" },
                  ...(eventValues.forAhbab ? [{ id: "ahbab", label: "unit_ahbaab" }] : []),
                ].map((tab) => (
                  <NavItem key={tab.id}>
                    <NavLink
                      onClick={() => toggle(tab.id)}
                      className={`fw-semibold py-3 ${
                        activeTab === tab.id
                          ? "active text-primary"
                          : "text-secondary"
                      }`}
                      style={{
                        cursor: "pointer",
                        position: "relative",
                        fontSize: "1rem",
                        border: "none",
                        background: "transparent",
                        transition: "all 0.4s ease",
                        color:
                          activeTab === tab.id
                            ? "#0284c7"
                            : "rgba(71,85,105,0.9)",
                        transform:
                          activeTab === tab.id ? "scale(1.02)" : "scale(1)",
                      }}
                    >
                      <GetLanguageString props={tab.label} />
                      <div
                        style={{
                          position: "absolute",
                          bottom: "6px",
                          left: activeTab === tab.id ? "25%" : "50%",
                          width: activeTab === tab.id ? "50%" : "0%",
                          height: "3px",
                          borderRadius: "3px",
                          backgroundColor: "#0ea5e9",
                          boxShadow:
                            activeTab === tab.id
                              ? "0 0 10px rgba(14,165,233,0.6)"
                              : "none",
                          transition: "all 0.35s ease",
                        }}
                      />
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>

              {/* Tab Content */}
              <div
                className="flex-grow-1 overflow-auto"
                style={{
                  borderRadius: "0 0 16px 16px",
                  backgroundColor: "#ffffff",
                  transition: "opacity 0.4s ease, transform 0.4s ease",
                  padding: "8px 0",
                  animation: "fadeIn 0.5s ease",
                }}
              >
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="rufqa">
                    <EventBarCodeAttendance
                      eventIdFromToken={eventId}
                      applyMarginTop={false}
                    />
                  </TabPane>
                  {eventValues.forAhbab && (
                    <TabPane tabId="ahbab">
                      <EventBarCodeAttendanceAhbab
                        eventIdFromToken={eventId}
                        applyMarginTop={false}
                      />
                    </TabPane>
                  )}
                </TabContent>
              </div>
            </div>
          </main>
        ) : (
          <div
            className="text-center"
            style={{
              backgroundColor: "white",
              width: "100vw",
              height: "100vh",
            }}
          >
            <br></br>
            <h2>{message}</h2>
          </div>
        )}
        <style>
          {`
            @keyframes fadeIn {
              from { opacity: 0; transform: translateY(10px); }
              to { opacity: 1; transform: translateY(0); }
            }

            @keyframes fadeInUp {
              from { opacity: 0; transform: translateY(20px); }
              to { opacity: 1; transform: translateY(0); }
            }

            @keyframes fadeInDown {
              from { opacity: 0; transform: translateY(-20px); }
              to { opacity: 1; transform: translateY(0); }
            }
          `}
        </style>
      </>
    </div>
  );
};

export default withRouter(EventSpecialAttendanceCase);
